import React from 'react';

const NewQuote: React.FC = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-light)' }}>
      <h2>New Quote</h2>
      <p>Coming soon.</p>
    </div>
  );
};

export default NewQuote;
